import { Actions } from '../constants/Actions';
import { RelationshipActions } from '../constants/RelationshipActions';

export const USERS_PERMISSIONS = {
  MANAGE: `users:${Actions.MANAGE}`,
  VIEW: `users:${Actions.VIEW}`,
  CREATE: `users:${Actions.CREATE}`,
  UPDATE: `users:${Actions.UPDATE}`,
  DELETE: `users:${Actions.DELETE}`,
  EXPORT: `users:${Actions.EXPORT}`,
  IMPORT: `users:${Actions.IMPORT}`,
  ACTIVATE: 'users:activate',
  DEACTIVATE: 'users:deactivate',
  ASSIGN_ROLE: `users:${RelationshipActions.ASSIGN_ROLE}`,
  IMPERSONATE: 'users:impersonate',
};
